var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelpGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#707070",
  clipPath: "url(#help-grey_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.98 9.98c0 5.503-4.477 9.98-9.98 9.98S.02 15.483.02 9.98 4.497 0 10 0s9.98 4.477 9.98 9.98m-1.71 0c0-4.562-3.708-8.27-8.27-8.27S1.73 5.419 1.73 9.98s3.708 8.27 8.27 8.27c4.562.028 8.27-3.708 8.27-8.27"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 13.2c-.552 0-1 .362-1 .808v.384c0 .446.448.808 1 .808s1-.362 1-.808v-.384c0-.446-.448-.808-1-.808M10 4.2c-1.654 0-3 1.282-3 2.857 0 .316.269.572.6.572s.6-.256.6-.572c0-.945.807-1.714 1.8-1.714s1.8.769 1.8 1.714-.807 1.714-1.8 1.714q-.02.001-.041.004c-.014 0-.027-.004-.041-.004-.332 0-.6.256-.6.572v2.286c0 .315.268.571.6.571s.6-.256.6-.571v-1.76C11.925 9.634 13 8.464 13 7.057 13 5.482 11.654 4.2 10 4.2"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "help-grey_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgHelpGrey;